enum PaymentType {
    COD = "COD",

    OFFLINE = "OFFLINE",

    ONLINE = "ONLINE",
}

export default PaymentType;
